import { minuteCount } from './minute-count';
import { summary } from './summary';
import { viewers } from './viewers';

export const statistics = {
  minuteCount,
  summary,
  viewers,
};
